export const ETHNICITY_OPTIONS = [
  '汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族',
  '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族',
  '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族',
  '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族',
  '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族',
  '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'
];

export const ROLE_OPTIONS = ['月嫂', '育儿师', '育婴师'];

export const CITY_OPTIONS = ['上海', '广州', '武汉', '深圳', '青岛'];

export const EDUCATION_OPTIONS = ['初中', '高中', '中专', '大专', '本科', '硕士研究生', '博士研究生'];

export const MARITAL_OPTIONS = ['未婚', '已婚', '离异'];

export const ZODIAC_SIGNS = ['白羊座', '金牛座', '双子座', '巨蟹座', '狮子座', '处女座', '天秤座', '天蝎座', '射手座', '摩羯座', '水瓶座', '双鱼座'];

export const CHINESE_ZODIAC = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];

export function matchEthnicity(value) {
  if (!value) return null;
  let idx = ETHNICITY_OPTIONS.indexOf(value);
  if (idx >= 0) return ETHNICITY_OPTIONS[idx];
  if (!value.endsWith('族')) {
    idx = ETHNICITY_OPTIONS.indexOf(value + '族');
    if (idx >= 0) return ETHNICITY_OPTIONS[idx];
  }
  const stripped = value.endsWith('族') ? value.slice(0, -1) : value;
  for (let i = 0; i < ETHNICITY_OPTIONS.length; i++) {
    if (ETHNICITY_OPTIONS[i].startsWith(stripped)) return ETHNICITY_OPTIONS[i];
  }
  return null;
}